import { SET_USER_INFO, SET_LOADING } from './mutation-types'

export default {
  [SET_USER_INFO] (state, data) {
    state.userInfo = data
  },
  [SET_LOADING] (state, data) {
    state.loading_state = data.state
    state.loading_text = data.text
  }
}
